import React from "react";
import ReactTable from "react-table";
import find from "lodash/find";
import moment from "moment";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import { ControlledInput } from "../../common/Input/Input";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ESPTargetsConfigurationGrid(props)
{
    const columns = [
		{
			id: "email",
			Header: "Service Partner Name",
			accessor: "sName",
		},
		{
			id: "SignedUpTarget",
			Header: "Signed Up Targets (%)",
			accessor: "SignedUpTarget",
            Cell:({original})=>(
                <>
                    <ControlledInput
                        placeholder="Signed Up Target"
                        name="SignedUpTarget"
                        value={original.SignedUpTarget}
                        autoFocus={props.activeRow&&props.activeRow===original.id&&props.activeFocus==="SignedUpTarget"}
                        autoComplete="off"
                        onChange={(e) =>{		
                            props.handleCursorPositionChange(e);		
                            props.handleInputChange(e.target.name, e.target.value,original);
                        }}												
                        onFocus={(e)=>e.currentTarget.setSelectionRange(props.CursorPosition.selectionStart, props.CursorPosition.selectionEnd)}
                    />
                </>
            ),
		},
		{
			id: "DeliveredTarget",
			Header: "Delivered Targets (%)",
			accessor: "DeliveredTarget",
            Cell:({original})=>(
                <>
                    <ControlledInput
                        placeholder="Delivered Target"
                        name="DeliveredTarget"
                        value={original.DeliveredTarget}
                        autoFocus={props.activeRow&&props.activeRow===original.id&&props.activeFocus==="DeliveredTarget"}
                        autoComplete="off"
                        onChange={(e) =>{		
                            props.handleCursorPositionChange(e);		
                            props.handleInputChange(e.target.name, e.target.value,original);
                        }}												
                        onFocus={(e)=>e.currentTarget.setSelectionRange(props.CursorPosition.selectionStart, props.CursorPosition.selectionEnd)}
                    />
                </>
            ),
		},        
    ];

    return (
            <ReactTable
                minRows={0}
                data={props.data || []}
                columns={columns}
                pageSize={props.data.length}
                sortable={false}
                showPagination={false}
                style={{overflowY: "initial",height: "300px"}}
                className="-striped hide-scrollbar"
            />
    )
}
